const now = new Date();

const one_day_after = new Date(now);
one_day_after.setDate(now.getDate() + 1);
const start_date = one_day_after.toISOString().split("T")[0];
const start_time = one_day_after.toTimeString().split(" ")[0].slice(0, 5);

const seven_days_after = new Date(now);
seven_days_after.setDate(now.getDate() + 7);
const end_date = seven_days_after.toISOString().split("T")[0];
const end_time = seven_days_after.toTimeString().split(" ")[0].slice(0, 5);

export const defaultEventInfoResponseBody = {
  id: 0,
  online: false,
  platform_url: "",
  title: "",
  description: "",
  thumbnail: "",
  start_date: start_date,
  end_date: end_date,
  start_time: start_time,
  end_time: end_time,
  accepted_terms: false,
  is_private: false,
  status: "published",
  event_category: {
    id: 0,
    title: "",
  },
  address: {
    id: 0,
    location_name: "",
    city_name: "",
    state: "",
    country: null,
    district: "",
    street: "",
    postal_code: "",
    number: "",
    additional_information: "",
    maps_url: "",
  },
  organizer_name: "",
  additional_images:[],
  total_revenue: 0,
  sold_quantity: 0,
};
